import { NgModule } from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {RouterModule} from '@angular/router';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {EmployeeComponent} from './components/employee/employee.component';
import {EmployeeDetailComponent} from './components/employee-detail/employee-detail.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    NgxDatatableModule
  ],
  declarations: [
    EmployeeComponent,
    EmployeeDetailComponent
  ]
})
export class EmployeeModule { }



// WEBPACK FOOTER //
// ./src/app/employee/employee.module.ts